import { gql } from '@apollo/client';

export const GET_PROF_DASHBOARD = gql`
  query GetProfDashboard {
    getProfDashboard {
      classe {
        id
        name
        operationid
        fin
        debut
        filiere {
          id
          name
        }
        niveau {
          id
          name
        }
        lycee {
          id
          name
        }
        users {
          id
          username
          firstname
          lastname
          email
          ville
          mdp
          shop
          avatar {
            name
            id
            media {
              url
            }
          }
          role {
            name
            id
          }
          note {
            qteca
            qtevente
            qtepro
            qtequiz
            qterebond

            moyennegenerale
            quiz
            pro
            cavente
            nbvente
            venterebond
          }
          quiztonotes {
            note
            createdAt
            quiz {
              name
              id
            }
          }
          commandes {
            status
            methodepaiement
            paymentreminder
            createdAt
          }
        }
      }
    }
    getUnpayedCoByEleve {
      id
      unpayedCA
    }
  }
`;
